<script>
  export let gallery;
  export let close;

  import { onMount } from 'svelte';
  import CloseButton from './CloseButton.svelte'

  import { Splide, SplideSlide } from '@splidejs/svelte-splide';
  import '@splidejs/splide/dist/css/splide.min.css';
  
  import UA from 'ua-parser-js';
  const ua = new UA();
  let isMobile = ua.getResult().device['type'] == 'mobile';

  let main;
  let thumbs;
  let isSingleImage = gallery.length === 1 ? true : false;

  const mainOptions = {
    type: 'loop',
    pagination: true,
    rewind: true,
    perMove   : 1,
    perPage   : 1,
    arrows: !isSingleImage,
  };


  const thumbsOptions = {
    type        : 'slide',
    rewind      : true,
    gap         : '1rem',
    pagination  : false,
    fixedWidth  : 110,
    fixedHeight : 70,
    cover       : true,
    // focus       : 'center',
    isNavigation: true,
    updateOnMove: true,
    arrows: false,
    
  };
  onMount( () => {
    if ( main && thumbs ) {
      main.sync( thumbs.splide );
    }
  } );

  let visible = true;
  function closeGallery () {
    visible = false;
    if(close){ close(); }
  }
  
</script>

<style>
.gallery {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100%;
  height: 100%;
}

.container {
  margin-top:  100px;
  text-align: center;
}

.close-container{
  position: relative;
  margin: auto;
  width: 50px;
  height: 50px;
  cursor: pointer;
  margin-bottom: 1rem;
}

.leftright{
  height: 4px;
  width: 50px;
  position: absolute;
  margin-top: 24px;
  background-color: #fff;
  border-radius: 2px;
  transform: rotate(45deg);
  transition: all .3s ease-in;
}

.rightleft{
  height: 4px;
  width: 50px;
  position: absolute;
  margin-top: 24px;
  background-color: #fff;
  border-radius: 2px;
  transform: rotate(-45deg);
  transition: all .3s ease-in;
}

label{
  color: white;
  font-family: Helvetica, Arial, sans-serif; 
  font-size: .6em;
  text-transform: uppercase;
  letter-spacing: 2px;
  transition: all .3s ease-in;
  opacity: 0;
}
.close{
  margin: 60px 0 0 5px;
  position: absolute;
}
.bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  background: rgba(0,0,0,0.98);
  width: 100%;
  height: 100%;
}

.close-container:hover .leftright{
  transform: rotate(-45deg);
  background-color: #fff;
}
.close-container:hover .rightleft{
  transform: rotate(45deg);
  background-color: #fff;
}
.close-container:hover label{
  opacity: 1;
}


:global(.splide:nth-child(1)){
    height: 75vh;
}

:global(.splide:nth-child(1)){
    height: 75vh;
}



:global(.container .splide:nth-child(2) .splide__slide.is-active) {
  border: 3px solid #fff !important;
}

:global(.splide:nth-child(2) .splide__list){
  justify-content: center;
}

:global(.splide){
  margin-top: 1em !important;
}

@media only screen and (max-width: 600px) {
  :global(.splide__slide){
    display: flex;
    align-items: center;
    height: 80vh;
  }
}

:global(.splide__arrow svg) {
  fill: #fff !important;
  width: 3em !important;
  height: 3em !important;
}

:global(.splide__arrow){
  background: none !important;
  width: 3em!important;
}

.close-position {
  position: absolute;
  z-index: 9999;
  right: 20px;
  top: 20px;
}
</style>

{#if visible}
<div class="gallery">
  <CloseButton close={closeGallery}/>  

  <div class="container">
    <Splide options={ mainOptions } bind:this={ main }>
      { #each gallery as slide }
        <SplideSlide>
          <img style="max-width: 100%; max-height: 75vh;" src={ slide}>
        </SplideSlide>
      { /each }
    </Splide>
  
    {#if !isMobile}
      {#if !isSingleImage}
      <Splide options={ thumbsOptions } bind:this={ thumbs }>
        { #each gallery as slide }
          <SplideSlide><img src={ slide }></SplideSlide>
        { /each }
      </Splide>
      {/if}
    {/if}
  </div>
  <div class="bg" on:click={closeGallery}></div>
</div>
{/if}